import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MetaService } from '../../../services/meta.service';
import { BlogService } from '../../../services/blog.service';

@Component({
  selector: 'app-blog-details',
  templateUrl: './blog-details.component.html',
  styleUrl: './blog-details.component.scss'
})
export class BlogDetailsComponent implements OnInit {
  blog: any;
  postUrl: string;
  terms: any[] = [];
  ext: string = '';

  contentKeywords = 'Technology Software, Web Development, API integration, PHP Development, Next.js development, React.js development, Node.js development, CMS Development, MVC Development, Android Application, iPhone Application, UI/UX Designing, UI Designing, 3D Designing, Logo Designing, Cloud computing, Artificial intelligence, Data analytics, Cybersecurity, Web development, Mobile app development, IT consulting, Virtual reality, Augmented reality, Web design Website development, Front-end development, Back-end development, Full-stack development, Responsive design, User interface (UI), User experience (UX), Custom web development, E-commerce development, Laravel development, Yii development, Codeigniter development, Content management systems (CMS), WordPress development, Drupal development, Magento development, Shopify development, Mobile-friendly websites, Cross-browser compatibility, Web application development, API integration, Website maintenance';

  constructor(private blogService: BlogService, private metaService: MetaService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    const baseUrl = window.location.origin;
    const slug = this.route.snapshot.paramMap.get('slug');

    if (slug) {
      this.blogService.getBlogDetails(slug).subscribe({
        next: (res) => {
          this.blog = res.data;
          this.terms = res.data.terms;
          this.postUrl = encodeURIComponent(window.location.href);

          // Get file extension if featured_image exists
          if (this.blog.featured_image) {
            const parts = this.blog.featured_image.split('.');
            this.ext = parts.length > 1 ? parts.pop()!.toLowerCase() : '';
          }

          // Set/update meta tags after data is loaded
          this.metaService.setMetaData({
            title: this.blog.title,
            description: this.blog.excerpt,
            keywords: this.contentKeywords,
            siteTitle: this.blog.title,
            pageUrl: `${baseUrl}${this.route.snapshot['_routerState'].url}`,
            imageUrl: this.blog.featured_image ?? `${baseUrl}/assets/img/xipetech.png`,
            ext: this.ext
          });
        },
        error: (err) => console.error('Failed to load blog data:', err)
      });
    } else {
      console.error('No slug found in route');
    }
  }
  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/noimage.png';
  }
}